(function () {
    const privacyPolicy = () => {
        const tabBtns = document.querySelectorAll('.privacy-policy__btn');

        tabBtns.forEach( btn => {
            btn.addEventListener('click', () => {
                const targetTab = document.getElementById(btn.getAttribute('data-tab'));
                targetTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        });
        
    }

    document.addEventListener('shopify:section:load', privacyPolicy);
    privacyPolicy();
})();